var _defineProperty2 = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _assertThisInitialized = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _toConsumableArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/traffic-control"), require("@driftt/web-auth"), require("react-redux"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda", "@driftt/traffic-control", "@driftt/web-auth", "react-redux"], t);else {
    var r = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/traffic-control"), require("@driftt/web-auth"), require("react-redux")) : t(e.react, e["@driftt/tide-core"], e.ramda, e["@driftt/traffic-control"], e["@driftt/web-auth"], e["react-redux"]);

    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e, t, r, n, o, a) {
  return function (e) {
    var t = {};

    function __webpack_require__(r) {
      if (t[r]) return t[r].exports;
      var n = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        __webpack_require__.d(r, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 17);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    e.exports = r(18);
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var r = function cssWithMappingToString(e, t) {
            var r = e[1] || "",
                n = e[3];
            if (!n) return r;

            if (t && "function" === typeof btoa) {
              var o = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(n),
                  a = n.sources.map(function (e) {
                return "/*# sourceURL=" + n.sourceRoot + e + " */";
              });

              return [r].concat(a).concat([o]).join("\n");
            }

            return [r].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
        }).join("");
      }, t.i = function (e, r) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var n = {}, o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (n[a] = !0);
        }

        for (o = 0; o < e.length; o++) {
          var i = e[o];
          null != i[0] && n[i[0]] || (r && !i[2] ? i[2] = r : r && (i[2] = "(" + i[2] + ") and (" + r + ")"), t.push(i));
        }
      }, t;
    };
  }, function (e, t, r) {
    "use strict";

    var n = {},
        o = function isOldIE() {
      var e;
      return function memorize() {
        return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
      };
    }(),
        a = function getTarget() {
      var e = {};
      return function memorize(t) {
        if ("undefined" === typeof e[t]) {
          var r = document.querySelector(t);
          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (n) {
            r = null;
          }
          e[t] = r;
        }

        return e[t];
      };
    }();

    function listToStyles(e, t) {
      for (var r = [], n = {}, o = 0; o < e.length; o++) {
        var a = e[o],
            i = t.base ? a[0] + t.base : a[0],
            c = {
          css: a[1],
          media: a[2],
          sourceMap: a[3]
        };
        n[i] ? n[i].parts.push(c) : r.push(n[i] = {
          id: i,
          parts: [c]
        });
      }

      return r;
    }

    function addStylesToDom(e, t) {
      for (var r = 0; r < e.length; r++) {
        var o = e[r],
            a = n[o.id],
            i = 0;

        if (a) {
          for (a.refs++; i < a.parts.length; i++) {
            a.parts[i](o.parts[i]);
          }

          for (; i < o.parts.length; i++) {
            a.parts.push(addStyle(o.parts[i], t));
          }
        } else {
          for (var c = []; i < o.parts.length; i++) {
            c.push(addStyle(o.parts[i], t));
          }

          n[o.id] = {
            id: o.id,
            refs: 1,
            parts: c
          };
        }
      }
    }

    function insertStyleElement(e) {
      var t = document.createElement("style");

      if ("undefined" === typeof e.attributes.nonce) {
        var n = r.nc;
        n && (e.attributes.nonce = n);
      }

      if (Object.keys(e.attributes).forEach(function (r) {
        t.setAttribute(r, e.attributes[r]);
      }), "function" === typeof e.insert) e.insert(t);else {
        var o = a(e.insert || "head");
        if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        o.appendChild(t);
      }
      return t;
    }

    var i = function replaceText() {
      var e = [];
      return function replace(t, r) {
        return e[t] = r, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, r, n) {
      var o = r ? "" : n.css;
      if (e.styleSheet) e.styleSheet.cssText = i(t, o);else {
        var a = document.createTextNode(o),
            c = e.childNodes;
        c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(a, c[t]) : e.appendChild(a);
      }
    }

    var c = null,
        s = 0;

    function addStyle(e, t) {
      var r, n, o;

      if (t.singleton) {
        var a = s++;
        r = c || (c = insertStyleElement(t)), n = applyToSingletonTag.bind(null, r, a, !1), o = applyToSingletonTag.bind(null, r, a, !0);
      } else r = insertStyleElement(t), n = function applyToTag(e, t, r) {
        var n = r.css,
            o = r.media,
            a = r.sourceMap;
        if (o && e.setAttribute("media", o), a && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, r, t), o = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(r);
      };

      return n(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else o();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = o());
      var r = listToStyles(e, t);
      return addStylesToDom(r, t), function update(e) {
        for (var o = [], a = 0; a < r.length; a++) {
          var i = r[a],
              c = n[i.id];
          c && (c.refs--, o.push(c));
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (var s = 0; s < o.length; s++) {
          var l = o[s];

          if (0 === l.refs) {
            for (var p = 0; p < l.parts.length; p++) {
              l.parts[p]();
            }

            delete n[l.id];
          }
        }
      };
    };
  }, function (e, t, r) {
    var n;
    !function () {
      "use strict";

      var r = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var o = typeof n;
            if ("string" === o || "number" === o) e.push(n);else if (Array.isArray(n) && n.length) {
              var a = classNames.apply(null, n);
              a && e.push(a);
            } else if ("object" === o) for (var i in n) {
              r.call(n, i) && n[i] && e.push(i);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (n = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = n);
    }();
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, r) {
    "use strict";

    var n = Object.prototype.hasOwnProperty,
        o = Array.isArray,
        a = function () {
      for (var e = [], t = 0; t < 256; ++t) {
        e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
      }

      return e;
    }(),
        i = function arrayToObject(e, t) {
      for (var r = t && t.plainObjects ? Object.create(null) : {}, n = 0; n < e.length; ++n) {
        "undefined" !== typeof e[n] && (r[n] = e[n]);
      }

      return r;
    };

    e.exports = {
      arrayToObject: i,
      assign: function assignSingleSource(e, t) {
        return Object.keys(t).reduce(function (e, r) {
          return e[r] = t[r], e;
        }, e);
      },
      combine: function combine(e, t) {
        return [].concat(e, t);
      },
      compact: function compact(e) {
        for (var t = [{
          obj: {
            o: e
          },
          prop: "o"
        }], r = [], n = 0; n < t.length; ++n) {
          for (var a = t[n], i = a.obj[a.prop], c = Object.keys(i), s = 0; s < c.length; ++s) {
            var l = c[s],
                p = i[l];
            "object" === typeof p && null !== p && -1 === r.indexOf(p) && (t.push({
              obj: i,
              prop: l
            }), r.push(p));
          }
        }

        return function compactQueue(e) {
          for (; e.length > 1;) {
            var t = e.pop(),
                r = t.obj[t.prop];

            if (o(r)) {
              for (var n = [], a = 0; a < r.length; ++a) {
                "undefined" !== typeof r[a] && n.push(r[a]);
              }

              t.obj[t.prop] = n;
            }
          }
        }(t), e;
      },
      decode: function decode(e, t, r) {
        var n = e.replace(/\+/g, " ");
        if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);

        try {
          return decodeURIComponent(n);
        } catch (o) {
          return n;
        }
      },
      encode: function encode(e, t, r) {
        if (0 === e.length) return e;
        var n = "string" === typeof e ? e : String(e);
        if ("iso-8859-1" === r) return escape(n).replace(/%u[0-9a-f]{4}/gi, function (e) {
          return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
        });

        for (var o = "", i = 0; i < n.length; ++i) {
          var c = n.charCodeAt(i);
          45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 ? o += n.charAt(i) : c < 128 ? o += a[c] : c < 2048 ? o += a[192 | c >> 6] + a[128 | 63 & c] : c < 55296 || c >= 57344 ? o += a[224 | c >> 12] + a[128 | c >> 6 & 63] + a[128 | 63 & c] : (i += 1, c = 65536 + ((1023 & c) << 10 | 1023 & n.charCodeAt(i)), o += a[240 | c >> 18] + a[128 | c >> 12 & 63] + a[128 | c >> 6 & 63] + a[128 | 63 & c]);
        }

        return o;
      },
      isBuffer: function isBuffer(e) {
        return !(!e || "object" !== typeof e) && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
      },
      isRegExp: function isRegExp(e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
      merge: function merge(e, t, r) {
        if (!t) return e;

        if ("object" !== typeof t) {
          if (o(e)) e.push(t);else {
            if (!e || "object" !== typeof e) return [e, t];
            (r && (r.plainObjects || r.allowPrototypes) || !n.call(Object.prototype, t)) && (e[t] = !0);
          }
          return e;
        }

        if (!e || "object" !== typeof e) return [e].concat(t);
        var a = e;
        return o(e) && !o(t) && (a = i(e, r)), o(e) && o(t) ? (t.forEach(function (t, o) {
          if (n.call(e, o)) {
            var a = e[o];
            a && "object" === typeof a && t && "object" === typeof t ? e[o] = merge(a, t, r) : e.push(t);
          } else e[o] = t;
        }), e) : Object.keys(t).reduce(function (e, o) {
          var a = t[o];
          return n.call(e, o) ? e[o] = merge(e[o], a, r) : e[o] = a, e;
        }, a);
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = String.prototype.replace,
        o = /%20/g;
    e.exports = {
      default: "RFC3986",
      formatters: {
        RFC1738: function RFC1738(e) {
          return n.call(e, o, "+");
        },
        RFC3986: function RFC3986(e) {
          return e;
        }
      },
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
  }, function (e, t) {
    e.exports = a;
  }, function (e) {
    e.exports = {
      SALES_INBOX_ID: 44,
      SALES_USER_ID: 46894
    };
  }, function (e) {
    e.exports = {
      SALES_INBOX_ID: 44,
      SALES_USER_ID: 46894
    };
  }, function (e) {
    e.exports = {
      SALES_INBOX_ID: 44,
      SALES_USER_ID: 46894
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(23),
        o = r(24),
        a = r(10);
    e.exports = {
      formats: a,
      parse: o,
      stringify: n
    };
  }, function (e, t, r) {
    !function webpackUniversalModuleDefinition(t, r) {
      e.exports = r();
    }(window, function () {
      return function (e) {
        var t = {};

        function __webpack_require__(r) {
          if (t[r]) return t[r].exports;
          var n = t[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
        }

        return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
          __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
          });
        }, __webpack_require__.r = function (e) {
          "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, __webpack_require__.t = function (e, t) {
          if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
          if (4 & t && "object" === typeof e && e && e.__esModule) return e;
          var r = Object.create(null);
          if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var n in e) {
            __webpack_require__.d(r, n, function (t) {
              return e[t];
            }.bind(null, n));
          }
          return r;
        }, __webpack_require__.n = function (e) {
          var t = e && e.__esModule ? function getDefault() {
            return e.default;
          } : function getModuleExports() {
            return e;
          };
          return __webpack_require__.d(t, "a", t), t;
        }, __webpack_require__.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 2);
      }([function (e, t) {
        var r = /^[aeiouAEIOU]/;
        t.startsWithVowel = function (e) {
          return r.test(e);
        }, t.capitalize = function (e, t) {
          return t.capitalize && (e = "".concat(e.charAt(0).toUpperCase()).concat(e.slice(1))), e;
        };
      }, function (e, t) {
        t.check = function (e, r) {
          if (r) {
            var n = new RegExp("".concat(r, "$"));
            e = e.replace(n, "");
          }

          return t.list.indexOf(e) > -1;
        }, t.list = ["eunuch", "eucalyptus", "eugenics", "eulogy", "euphemism", "euphony", "euphoria", "eureka", "euro", "european", "euphemistic", "euphonic", "euphoric", "euphemistically", "euphonically", "euphorically", "heir", "heiress", "herb", "homage", "honesty", "honor", "honour", "hour", "honest", "honorous", "honestly", "hourly", "one", "ouija", "once", "ubiquity", "udometer", "ufo", "uke", "ukelele", "ululate", "unicorn", "unicycle", "uniform", "unify", "union", "unison", "unit", "unity", "universe", "university", "upas", "ural", "uranium", "urea", "ureter", "urethra", "urine", "urologist", "urology", "urus", "usage", "use", "user", "usual", "usurp", "usury", "utensil", "uterus", "utility", "utopia", "utricle", "uvarovite", "uvea", "uvula", "utah", "utahn", "ubiquitous", "ugandan", "ukrainian", "unanimous", "unicameral", "unified", "unique", "unisex", "universal", "urinal", "urological", "useful", "useless", "usurious", "usurped", "utilitarian", "utopic", "ubiquitously", "unanimously", "unicamerally", "uniquely", "universally", "urologically", "usefully", "uselessly", "usuriously", "yttria", "yggdrasil", "ylem", "yperite", "ytterbia", "ytterbium", "yttrium", "ytterbous", "ytterbic", "yttric", "f", "h", "l", "m", "n", "r", "s", "u", "x"];
      }, function (e, t, r) {
        var n = r(0).capitalize,
            o = r(1),
            a = r(3),
            i = function indefinite(e) {
          var t,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return a.some(function (n) {
            if (n.check(e, r)) return t = n.run(e, r), !0;
          }), c(t, r, e);
        },
            c = function handleOptions(e, t, r) {
          return e = n(e, t), t.articleOnly ? e : "".concat(e, " ").concat(r);
        };

        i.irregularWords = o.list, e.exports = i;
      }, function (e, t, r) {
        e.exports = [r(4), r(5), r(6)];
      }, function (e, t) {
        var r = /^([0-9,]+)/,
            n = /^(11|8|18)/,
            o = /^(11|18)/;
        t.check = function (e) {
          return r.test(e);
        }, t.run = function (e, t) {
          var a = e.toString().match(r)[1].replace(/,/g, ""),
              i = "a";

          if (n.test(a)) {
            var c = o.test(a);
            i = c && 4 === a.length ? "colloquial" === t.numbers ? "an" : "a" : c && (a.length - 2) % 3 === 0 ? "an" : a.startsWith("8") ? "an" : "a";
          }

          return i;
        };
      }, function (e, t, r) {
        var n = r(0).startsWithVowel,
            o = /^[A-Z]+$/,
            a = /^[UFHLMNRSX]/;
        t.check = function (e, t) {
          return !t.caseInsensitive && o.test(e.split(" ")[0]);
        }, t.run = function (e) {
          var t = function isIrregularAcronym(e) {
            return a.test(e.charAt(0));
          }(e);

          return function bothOrNeither(e, t) {
            return e === t;
          }(n(e), t) ? "a" : "an";
        };
      }, function (e, t, r) {
        var n = r(0).startsWithVowel,
            o = r(1),
            a = /[\s'-]/;
        t.check = function () {
          return !0;
        }, t.run = function (e, t) {
          var r = function checkForIrregulars(e) {
            return [null, "s", "es", "ed"].reduce(function (t, r) {
              return t || o.check(e, r);
            }, !1);
          }(function getFirst(e) {
            return e.split(a)[0].toLowerCase();
          }(e));

          return function xor(e, t) {
            return (e || t) && !(e && t);
          }(n(e), r) ? "an" : "a";
        };
      }]);
    });
  }, function (e, t, r) {
    e.exports = r(35);
  }, function (e, t, r) {
    var n = function (e) {
      "use strict";

      var t,
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = "function" === typeof Symbol ? Symbol : {},
          a = o.iterator || "@@iterator",
          i = o.asyncIterator || "@@asyncIterator",
          c = o.toStringTag || "@@toStringTag";

      function define(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        define({}, "");
      } catch (A) {
        define = function define(e, t, r) {
          return e[t] = r;
        };
      }

      function wrap(e, t, r, n) {
        var o = t && t.prototype instanceof Generator ? t : Generator,
            a = Object.create(o.prototype),
            i = new Context(n || []);
        return a._invoke = function makeInvokeMethod(e, t, r) {
          var n = s;
          return function invoke(o, a) {
            if (n === p) throw new Error("Generator is already running");

            if (n === u) {
              if ("throw" === o) throw a;
              return doneResult();
            }

            for (r.method = o, r.arg = a;;) {
              var i = r.delegate;

              if (i) {
                var c = maybeInvokeDelegate(i, r);

                if (c) {
                  if (c === f) continue;
                  return c;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === s) throw n = u, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = p;
              var d = tryCatch(e, t, r);

              if ("normal" === d.type) {
                if (n = r.done ? u : l, d.arg === f) continue;
                return {
                  value: d.arg,
                  done: r.done
                };
              }

              "throw" === d.type && (n = u, r.method = "throw", r.arg = d.arg);
            }
          };
        }(e, r, i), a;
      }

      function tryCatch(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (A) {
          return {
            type: "throw",
            arg: A
          };
        }
      }

      e.wrap = wrap;
      var s = "suspendedStart",
          l = "suspendedYield",
          p = "executing",
          u = "completed",
          f = {};

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      var d = {};

      d[a] = function () {
        return this;
      };

      var y = Object.getPrototypeOf,
          m = y && y(y(values([])));
      m && m !== r && n.call(m, a) && (d = m);
      var h = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(d);

      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (t) {
          define(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function AsyncIterator(e, t) {
        var r;

        this._invoke = function enqueue(o, a) {
          function callInvokeWithMethodAndArg() {
            return new t(function (r, i) {
              !function invoke(r, o, a, i) {
                var c = tryCatch(e[r], e, o);

                if ("throw" !== c.type) {
                  var s = c.arg,
                      l = s.value;
                  return l && "object" === typeof l && n.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    invoke("next", e, a, i);
                  }, function (e) {
                    invoke("throw", e, a, i);
                  }) : t.resolve(l).then(function (e) {
                    s.value = e, a(s);
                  }, function (e) {
                    return invoke("throw", e, a, i);
                  });
                }

                i(c.arg);
              }(o, a, r, i);
            });
          }

          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(e, r) {
        var n = e.iterator[r.method];

        if (n === t) {
          if (r.delegate = null, "throw" === r.method) {
            if (e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method)) return f;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return f;
        }

        var o = tryCatch(n, e.iterator, r.arg);
        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, f;
        var a = o.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, f) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, f);
      }

      function pushTryEntry(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function resetTryEntry(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(e) {
        if (e) {
          var r = e[a];
          if (r) return r.call(e);
          if ("function" === typeof e.next) return e;

          if (!isNaN(e.length)) {
            var o = -1,
                i = function next() {
              for (; ++o < e.length;) {
                if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
              }

              return next.value = t, next.done = !0, next;
            };

            return i.next = i;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: t,
          done: !0
        };
      }

      return GeneratorFunction.prototype = h.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunction.displayName = define(GeneratorFunctionPrototype, c, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" === typeof e && e.constructor;
        return !!t && (t === GeneratorFunction || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, define(e, c, "GeneratorFunction")), e.prototype = Object.create(h), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[i] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, a) {
        void 0 === a && (a = Promise);
        var i = new AsyncIterator(wrap(t, r, n, o), a);
        return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, defineIteratorMethods(h), define(h, c, "Generator"), h[a] = function () {
        return this;
      }, h.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function next() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return next.value = r, next.done = !1, next;
          }

          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var r = this;

          function handle(n, o) {
            return i.type = "throw", i.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
                i = a.completion;
            if ("root" === a.tryLoc) return handle("end");

            if (a.tryLoc <= this.prev) {
              var c = n.call(a, "catchLoc"),
                  s = n.call(a, "finallyLoc");

              if (c && s) {
                if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
              } else if (c) {
                if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var a = o;
              break;
            }
          }

          a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
          var i = a ? a.completion : {};
          return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, f) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), f;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), f;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                resetTryEntry(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
          return this.delegate = {
            iterator: values(e),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = t), f;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = n;
    } catch (o) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (e, t, r) {
    var n = r(20);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(6)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(5)(!0)).push([e.i, ".property-creator-navigation {\n  width: 100%;\n  padding: 30px;\n  background: var(--main-white);\n  display: inline-flex;\n  border-top: 1px solid var(--main-navy-light);\n  position: fixed;\n  bottom: 0;\n  z-index: 2;\n}\n\n.property-creator-navigation button {\n  margin: 0 8px 0 0;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,4CAA4C;EAC5C,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB",
      file: "style.css",
      sourcesContent: [".property-creator-navigation {\n  width: 100%;\n  padding: 30px;\n  background: var(--main-white);\n  display: inline-flex;\n  border-top: 1px solid var(--main-navy-light);\n  position: fixed;\n  bottom: 0;\n  z-index: 2;\n}\n\n.property-creator-navigation button {\n  margin: 0 8px 0 0;\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(22);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(6)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(5)(!0)).push([e.i, ".property-editor-navigation {\n  width: 100%;\n  padding: 30px;\n  background: var(--main-white);\n  display: inline-flex;\n  border-top: 1px solid var(--color-p1-4);\n  z-index: 2;\n}\n\n.property-editor-navigation-gradient {\n  background-image: linear-gradient(-180deg, rgba(118,149,165,0.00) 0%, #7695A5 100%);\n  height: 95px;\n  width: 100%;\n  display: block;\n  position: absolute;\n  bottom: 30px;\n  left: 0;\n  z-index: 1;\n}\n\n.property-editor-navigation button {\n  width: calc(50% - 35px);\n  margin: 0 15px 0 0;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".property-editor-navigation {\n  width: 100%;\n  padding: 30px;\n  background: var(--main-white);\n  display: inline-flex;\n  border-top: 1px solid var(--color-p1-4);\n  z-index: 2;\n}\n\n.property-editor-navigation-gradient {\n  background-image: linear-gradient(-180deg, rgba(118,149,165,0.00) 0%, #7695A5 100%);\n  height: 95px;\n  width: 100%;\n  display: block;\n  position: absolute;\n  bottom: 30px;\n  left: 0;\n  z-index: 1;\n}\n\n.property-editor-navigation button {\n  width: calc(50% - 35px);\n  margin: 0 15px 0 0;\n}\n"]
    }]);
  }, function (e, t, r) {
    "use strict";

    var n = r(9),
        o = r(10),
        a = Object.prototype.hasOwnProperty,
        i = {
      brackets: function brackets(e) {
        return e + "[]";
      },
      comma: "comma",
      indices: function indices(e, t) {
        return e + "[" + t + "]";
      },
      repeat: function repeat(e) {
        return e;
      }
    },
        c = Array.isArray,
        s = Array.prototype.push,
        l = function pushToArray(e, t) {
      s.apply(e, c(t) ? t : [t]);
    },
        p = Date.prototype.toISOString,
        u = {
      addQueryPrefix: !1,
      allowDots: !1,
      charset: "utf-8",
      charsetSentinel: !1,
      delimiter: "&",
      encode: !0,
      encoder: n.encode,
      encodeValuesOnly: !1,
      formatter: o.formatters[o.default],
      indices: !1,
      serializeDate: function serializeDate(e) {
        return p.call(e);
      },
      skipNulls: !1,
      strictNullHandling: !1
    },
        f = function stringify(e, t, r, o, a, i, s, p, f, d, y, m, h) {
      var A = e;

      if ("function" === typeof s ? A = s(t, A) : A instanceof Date ? A = d(A) : "comma" === r && c(A) && (A = A.join(",")), null === A) {
        if (o) return i && !m ? i(t, u.encoder, h) : t;
        A = "";
      }

      if ("string" === typeof A || "number" === typeof A || "boolean" === typeof A || n.isBuffer(A)) return i ? [y(m ? t : i(t, u.encoder, h)) + "=" + y(i(A, u.encoder, h))] : [y(t) + "=" + y(String(A))];
      var v,
          b = [];
      if ("undefined" === typeof A) return b;
      if (c(s)) v = s;else {
        var g = Object.keys(A);
        v = p ? g.sort(p) : g;
      }

      for (var E = 0; E < v.length; ++E) {
        var _ = v[E];
        a && null === A[_] || (c(A) ? l(b, stringify(A[_], "function" === typeof r ? r(t, _) : t, r, o, a, i, s, p, f, d, y, m, h)) : l(b, stringify(A[_], t + (f ? "." + _ : "[" + _ + "]"), r, o, a, i, s, p, f, d, y, m, h)));
      }

      return b;
    };

    e.exports = function (e, t) {
      var r,
          n = e,
          s = function normalizeStringifyOptions(e) {
        if (!e) return u;
        if (null !== e.encoder && void 0 !== e.encoder && "function" !== typeof e.encoder) throw new TypeError("Encoder has to be a function.");
        var t = e.charset || u.charset;
        if ("undefined" !== typeof e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var r = o.default;

        if ("undefined" !== typeof e.format) {
          if (!a.call(o.formatters, e.format)) throw new TypeError("Unknown format option provided.");
          r = e.format;
        }

        var n = o.formatters[r],
            i = u.filter;
        return ("function" === typeof e.filter || c(e.filter)) && (i = e.filter), {
          addQueryPrefix: "boolean" === typeof e.addQueryPrefix ? e.addQueryPrefix : u.addQueryPrefix,
          allowDots: "undefined" === typeof e.allowDots ? u.allowDots : !!e.allowDots,
          charset: t,
          charsetSentinel: "boolean" === typeof e.charsetSentinel ? e.charsetSentinel : u.charsetSentinel,
          delimiter: "undefined" === typeof e.delimiter ? u.delimiter : e.delimiter,
          encode: "boolean" === typeof e.encode ? e.encode : u.encode,
          encoder: "function" === typeof e.encoder ? e.encoder : u.encoder,
          encodeValuesOnly: "boolean" === typeof e.encodeValuesOnly ? e.encodeValuesOnly : u.encodeValuesOnly,
          filter: i,
          formatter: n,
          serializeDate: "function" === typeof e.serializeDate ? e.serializeDate : u.serializeDate,
          skipNulls: "boolean" === typeof e.skipNulls ? e.skipNulls : u.skipNulls,
          sort: "function" === typeof e.sort ? e.sort : null,
          strictNullHandling: "boolean" === typeof e.strictNullHandling ? e.strictNullHandling : u.strictNullHandling
        };
      }(t);

      "function" === typeof s.filter ? n = (0, s.filter)("", n) : c(s.filter) && (r = s.filter);
      var p,
          d = [];
      if ("object" !== typeof n || null === n) return "";
      p = t && t.arrayFormat in i ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices";
      var y = i[p];
      r || (r = Object.keys(n)), s.sort && r.sort(s.sort);

      for (var m = 0; m < r.length; ++m) {
        var h = r[m];
        s.skipNulls && null === n[h] || l(d, f(n[h], h, y, s.strictNullHandling, s.skipNulls, s.encode ? s.encoder : null, s.filter, s.sort, s.allowDots, s.serializeDate, s.formatter, s.encodeValuesOnly, s.charset));
      }

      var A = d.join(s.delimiter),
          v = !0 === s.addQueryPrefix ? "?" : "";
      return s.charsetSentinel && ("iso-8859-1" === s.charset ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"), A.length > 0 ? v + A : "";
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(9),
        o = Object.prototype.hasOwnProperty,
        a = {
      allowDots: !1,
      allowPrototypes: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      comma: !1,
      decoder: n.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1e3,
      parseArrays: !0,
      plainObjects: !1,
      strictNullHandling: !1
    },
        i = function interpretNumericEntities(e) {
      return e.replace(/&#(\d+);/g, function (e, t) {
        return String.fromCharCode(parseInt(t, 10));
      });
    },
        c = function parseQueryStringKeys(e, t, r) {
      if (e) {
        var n = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
            a = /(\[[^[\]]*])/g,
            i = /(\[[^[\]]*])/.exec(n),
            c = i ? n.slice(0, i.index) : n,
            s = [];

        if (c) {
          if (!r.plainObjects && o.call(Object.prototype, c) && !r.allowPrototypes) return;
          s.push(c);
        }

        for (var l = 0; null !== (i = a.exec(n)) && l < r.depth;) {
          if (l += 1, !r.plainObjects && o.call(Object.prototype, i[1].slice(1, -1)) && !r.allowPrototypes) return;
          s.push(i[1]);
        }

        return i && s.push("[" + n.slice(i.index) + "]"), function parseObject(e, t, r) {
          for (var n = t, o = e.length - 1; o >= 0; --o) {
            var a,
                i = e[o];
            if ("[]" === i && r.parseArrays) a = [].concat(n);else {
              a = r.plainObjects ? Object.create(null) : {};
              var c = "[" === i.charAt(0) && "]" === i.charAt(i.length - 1) ? i.slice(1, -1) : i,
                  s = parseInt(c, 10);
              r.parseArrays || "" !== c ? !isNaN(s) && i !== c && String(s) === c && s >= 0 && r.parseArrays && s <= r.arrayLimit ? (a = [])[s] = n : a[c] = n : a = {
                0: n
              };
            }
            n = a;
          }

          return n;
        }(s, t, r);
      }
    };

    e.exports = function (e, t) {
      var r = function normalizeParseOptions(e) {
        if (!e) return a;
        if (null !== e.decoder && void 0 !== e.decoder && "function" !== typeof e.decoder) throw new TypeError("Decoder has to be a function.");
        if ("undefined" !== typeof e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
        var t = "undefined" === typeof e.charset ? a.charset : e.charset;
        return {
          allowDots: "undefined" === typeof e.allowDots ? a.allowDots : !!e.allowDots,
          allowPrototypes: "boolean" === typeof e.allowPrototypes ? e.allowPrototypes : a.allowPrototypes,
          arrayLimit: "number" === typeof e.arrayLimit ? e.arrayLimit : a.arrayLimit,
          charset: t,
          charsetSentinel: "boolean" === typeof e.charsetSentinel ? e.charsetSentinel : a.charsetSentinel,
          comma: "boolean" === typeof e.comma ? e.comma : a.comma,
          decoder: "function" === typeof e.decoder ? e.decoder : a.decoder,
          delimiter: "string" === typeof e.delimiter || n.isRegExp(e.delimiter) ? e.delimiter : a.delimiter,
          depth: "number" === typeof e.depth ? e.depth : a.depth,
          ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
          interpretNumericEntities: "boolean" === typeof e.interpretNumericEntities ? e.interpretNumericEntities : a.interpretNumericEntities,
          parameterLimit: "number" === typeof e.parameterLimit ? e.parameterLimit : a.parameterLimit,
          parseArrays: !1 !== e.parseArrays,
          plainObjects: "boolean" === typeof e.plainObjects ? e.plainObjects : a.plainObjects,
          strictNullHandling: "boolean" === typeof e.strictNullHandling ? e.strictNullHandling : a.strictNullHandling
        };
      }(t);

      if ("" === e || null === e || "undefined" === typeof e) return r.plainObjects ? Object.create(null) : {};

      for (var s = "string" === typeof e ? function parseQueryStringValues(e, t) {
        var r,
            c = {},
            s = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
            l = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
            p = s.split(t.delimiter, l),
            u = -1,
            f = t.charset;
        if (t.charsetSentinel) for (r = 0; r < p.length; ++r) {
          0 === p[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === p[r] ? f = "utf-8" : "utf8=%26%2310003%3B" === p[r] && (f = "iso-8859-1"), u = r, r = p.length);
        }

        for (r = 0; r < p.length; ++r) {
          if (r !== u) {
            var d,
                y,
                m = p[r],
                h = m.indexOf("]="),
                A = -1 === h ? m.indexOf("=") : h + 1;
            -1 === A ? (d = t.decoder(m, a.decoder, f), y = t.strictNullHandling ? null : "") : (d = t.decoder(m.slice(0, A), a.decoder, f), y = t.decoder(m.slice(A + 1), a.decoder, f)), y && t.interpretNumericEntities && "iso-8859-1" === f && (y = i(y)), y && t.comma && y.indexOf(",") > -1 && (y = y.split(",")), o.call(c, d) ? c[d] = n.combine(c[d], y) : c[d] = y;
          }
        }

        return c;
      }(e, r) : e, l = r.plainObjects ? Object.create(null) : {}, p = Object.keys(s), u = 0; u < p.length; ++u) {
        var f = p[u],
            d = c(f, s[f], r);
        l = n.merge(l, d, r);
      }

      return n.compact(l);
    };
  }, function (e, t, r) {
    var n = r(26);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(6)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(5)(!0)).push([e.i, ".property-selector-property {\n  width: 100%;\n  padding: 0 0 15px 0;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.property-selector-property:not(:last-child) {\n  border-bottom: 2px dotted var(--color-p1-5);\n}\n\n.property-selector-content {\n  padding: 15px 30px 0;\n  margin: 0 0 0 0;\n  overflow-y: scroll;\n  max-height: calc(100vh - 268px)\n}\n\n.property-selector-property > span {\n  display: inline-block;\n  vertical-align: top;\n  margin: 4px 0 0 5px;\n  color: var(--color-p1-10);\n  font-family: var(--main-font-family--semibold);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.property-selector-property > p {\n  margin: 0;\n  margin-left: 31px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.property-selector-content::-webkit-scrollbar {\n  width: 5px;\n}\n\n.property-selector-content::-webkit-scrollbar-thumb{\n    border-radius:10px;\n    height: 30px;\n    width: 8px;\n    background:transparent;\n}\n\n.property-selector-content:hover::-webkit-scrollbar-thumb {\n  background: var(--main-navy-extra-dark) ;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,sBAAsB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C",
      file: "style.css",
      sourcesContent: [".property-selector-property {\n  width: 100%;\n  padding: 0 0 15px 0;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.property-selector-property:not(:last-child) {\n  border-bottom: 2px dotted var(--color-p1-5);\n}\n\n.property-selector-content {\n  padding: 15px 30px 0;\n  margin: 0 0 0 0;\n  overflow-y: scroll;\n  max-height: calc(100vh - 268px)\n}\n\n.property-selector-property > span {\n  display: inline-block;\n  vertical-align: top;\n  margin: 4px 0 0 5px;\n  color: var(--color-p1-10);\n  font-family: var(--main-font-family--semibold);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.property-selector-property > p {\n  margin: 0;\n  margin-left: 31px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.property-selector-content::-webkit-scrollbar {\n  width: 5px;\n}\n\n.property-selector-content::-webkit-scrollbar-thumb{\n    border-radius:10px;\n    height: 30px;\n    width: 8px;\n    background:transparent;\n}\n\n.property-selector-content:hover::-webkit-scrollbar-thumb {\n  background: var(--main-navy-extra-dark) ;\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(28);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(6)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(5)(!0)).push([e.i, ".property-creator-editor {\n  width: 100%;\n}\n\n.property-creator-editor-content {\n  padding: 30px; \n}\n\n.property-creator-property-component input,\n.property-creator-property-component label {\n  width: 100%;\n}\n\n.property-creator-enum-options-label {\n  margin: 30px 0 0 0;\n}\n\n.property-creator-enum-options-label span {\n  display: block;\n  margin: 5px 0 0 0;\n  color: var(--main-navy-dark);\n}\n\n.property-creator-property-component textarea {\n  max-width: 100%;\n  height: 230px;\n  resize: none;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd",
      file: "style.css",
      sourcesContent: [".property-creator-editor {\n  width: 100%;\n}\n\n.property-creator-editor-content {\n  padding: 30px; \n}\n\n.property-creator-property-component input,\n.property-creator-property-component label {\n  width: 100%;\n}\n\n.property-creator-enum-options-label {\n  margin: 30px 0 0 0;\n}\n\n.property-creator-enum-options-label span {\n  display: block;\n  margin: 5px 0 0 0;\n  color: var(--main-navy-dark);\n}\n\n.property-creator-property-component textarea {\n  max-width: 100%;\n  height: 230px;\n  resize: none;\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(30);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(6)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(5)(!0)).push([e.i, ".property-creator {\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n}\n\n.property-creator-section-title {\n  padding: 15px 0 30px 30px;\n  margin: 15px 0 0;\n  font-size: 16px;\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n  border-bottom: 1px solid var(--main-navy-extra-light);\n}\n\n.property-selector,\n.property-creator-editor {\n  transition: transform .3s ease-out;\n  position: absolute;\n}\n\n.property-creator-step--1 .property-selector {\n  transform: translateX(0px);\n}\n\n.property-creator-step--2 .property-selector {\n  transform: translateX(-1000px);\n}\n\n.property-creator-step--1 .property-creator-editor {\n  transform: translateX(1000px);\n}\n\n.property-creator-step--2 .property-creator-editor {\n  transform: translateX(0px);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B",
      file: "style.css",
      sourcesContent: [".property-creator {\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n}\n\n.property-creator-section-title {\n  padding: 15px 0 30px 30px;\n  margin: 15px 0 0;\n  font-size: 16px;\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n  border-bottom: 1px solid var(--main-navy-extra-light);\n}\n\n.property-selector,\n.property-creator-editor {\n  transition: transform .3s ease-out;\n  position: absolute;\n}\n\n.property-creator-step--1 .property-selector {\n  transform: translateX(0px);\n}\n\n.property-creator-step--2 .property-selector {\n  transform: translateX(-1000px);\n}\n\n.property-creator-step--1 .property-creator-editor {\n  transform: translateX(1000px);\n}\n\n.property-creator-step--2 .property-creator-editor {\n  transform: translateX(0px);\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(32);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(6)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(5)(!0)).push([e.i, ".property-creator-modal .property-selector,\n.property-creator-modal .property-creator-editor {\n  min-height: 300px;\n  position: relative;\n}\n\n.property-creator-modal .property-creator-section-title {\n  border-bottom: none;\n  color: var(--color-p1-10);\n  font-family: var(--main-font-family--semibold);\n  margin: 0;\n  padding: 0;\n}\n\n.property-creator-modal .property-selector-content,\n.property-creator-modal .property-creator-editor-content {\n  padding: 16px 0;\n}\n\n.property-creator-modal .property-selector-property:not(:last-child) {\n  border-bottom: none;\n}\n\n.property-creator-modal label.tide-label.property-selector-property {\n  margin-bottom: 0;\n}\n\n.property-creator-modal .property-creator-property-component {\n  margin-left: 16px;\n}\n\n.property-creator-modal .property-creator-property-component input.tide-input {\n  width: 325px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd",
      file: "style.css",
      sourcesContent: [".property-creator-modal .property-selector,\n.property-creator-modal .property-creator-editor {\n  min-height: 300px;\n  position: relative;\n}\n\n.property-creator-modal .property-creator-section-title {\n  border-bottom: none;\n  color: var(--color-p1-10);\n  font-family: var(--main-font-family--semibold);\n  margin: 0;\n  padding: 0;\n}\n\n.property-creator-modal .property-selector-content,\n.property-creator-modal .property-creator-editor-content {\n  padding: 16px 0;\n}\n\n.property-creator-modal .property-selector-property:not(:last-child) {\n  border-bottom: none;\n}\n\n.property-creator-modal label.tide-label.property-selector-property {\n  margin-bottom: 0;\n}\n\n.property-creator-modal .property-creator-property-component {\n  margin-left: 16px;\n}\n\n.property-creator-modal .property-creator-property-component input.tide-input {\n  width: 325px;\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(34);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(6)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(5)(!0)).push([e.i, "", "", {
      version: 3,
      sources: [],
      names: [],
      mappings: "",
      file: "style.css"
    }]);
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(2),
        o = r.n(n);

    function asyncGeneratorStep(e, t, r, n, o, a, i) {
      try {
        var c = e[a](i),
            s = c.value;
      } catch (l) {
        return void r(l);
      }

      c.done ? t(s) : Promise.resolve(s).then(n, o);
    }

    function _asyncToGenerator(e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (n, o) {
          var a = e.apply(t, r);

          function _next(e) {
            asyncGeneratorStep(a, n, o, _next, _throw, "next", e);
          }

          function _throw(e) {
            asyncGeneratorStep(a, n, o, _next, _throw, "throw", e);
          }

          _next(void 0);
        });
      };
    }

    var a = r(0),
        i = r.n(a),
        c = r(11),
        s = r(7),
        l = r.n(s),
        p = r(3),
        u = r(1),
        f = function () {
      var e = _asyncToGenerator(o.a.mark(function _callee(e) {
        return o.a.wrap(function _callee$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", new Promise(function (t) {
                  return setTimeout(t, e);
                }));

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, _callee);
      }));

      return function pause(t) {
        return e.apply(this, arguments);
      };
    }(),
        d = (r(19), function (_ref) {
      var e = _ref.selected,
          t = _ref.onSelect,
          r = _ref.onNext,
          n = _ref.onCancel;
      return i.a.createElement(u.Div, {
        className: "property-creator-navigation"
      }, i.a.createElement(u.Button, {
        type: "secondary",
        disabled: !e,
        onClick: r
      }, "Next"), i.a.createElement(u.Button, {
        type: "subtle",
        onClick: n
      }, "Cancel"));
    }),
        y = (r(21), function (_ref2) {
      var e = _ref2.onSave,
          t = _ref2.onBack,
          r = _ref2.isValid;
      return i.a.createElement(u.Div, null, i.a.createElement(u.Div, {
        className: "property-creator-navigation-gradient"
      }), i.a.createElement(u.Div, {
        className: "property-creator-navigation"
      }, i.a.createElement(u.Button, {
        type: "secondary",
        disabled: !r,
        onClick: e
      }, "Save"), i.a.createElement(u.Button, {
        type: "subtle",
        onClick: t
      }, "Go Back")));
    }),
        m = r(8);

    function _defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ownKeys(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function _objectSpread2(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
          _defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var h = {
      QA: r(12),
      EU: r(13),
      US: r(14)
    },
        A = _objectSpread2(_objectSpread2({}, window.DRIFT_CONFIG || {}), h[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "QA")]),
        v = r(15),
        b = r.n(v),
        g = Object(m.createAuthedHttpClient)({
      baseConfig: {
        baseURL: A.CUSTOMER_API,
        paramsSerializer: function paramsSerializer(e) {
          return b.a.stringify(e, {
            arrayFormat: "repeat"
          });
        }
      }
    }),
        E = Object(m.createAuthedHttpClient)({
      baseConfig: {
        baseURL: A.ACCOUNTS_API
      }
    }),
        _ = function () {
      var e = _asyncToGenerator(o.a.mark(function _callee(e) {
        return o.a.wrap(function _callee$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", E.post("attrib", e));

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, _callee);
      }));

      return function createAccountProperty(t) {
        return e.apply(this, arguments);
      };
    }(),
        C = function () {
      var e = _asyncToGenerator(o.a.mark(function _callee2(e) {
        return o.a.wrap(function _callee2$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", g.post("/property_definitions", e));

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, _callee2);
      }));

      return function createContactProperty(t) {
        return e.apply(this, arguments);
      };
    }(),
        x = r(4),
        w = (x.access.hasScopes, x.access.hasAnyScope, x.access.hasGates);

    x.access.hasAccess, x.access.isAdmin, x.access.isAgent, x.access.isUser;

    var O = /*#__PURE__*/function (_a$Component) {
      _inherits(LabelOnlyProperty_LabelOnlyProperty, _a$Component);

      var _super = _createSuper(LabelOnlyProperty_LabelOnlyProperty);

      function LabelOnlyProperty_LabelOnlyProperty(e) {
        var _this;

        _classCallCheck(this, LabelOnlyProperty_LabelOnlyProperty);

        _this = _super.call(this, e), _this.onLabelChange = function (e) {
          e.persist(), _this.setState(function (_ref3) {
            var t = _ref3.definition;
            return {
              definition: Object(p.merge)(t, {
                label: e.target.value
              })
            };
          }, _this.updateParent);
        }, _this.checkValidity = function () {
          var e = _this.state.definition.label;
          return !!e && e.length;
        }, _this.state = {
          isValid: !1,
          definition: {}
        };
        return _this;
      }

      _createClass(LabelOnlyProperty_LabelOnlyProperty, [{
        key: "updateParent",
        value: function updateParent() {
          var _this2 = this;

          this.setState({
            isValid: this.checkValidity()
          }, function () {
            return _this2.props.onChange(_this2.state);
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props.value,
              t = void 0 === e ? "" : e;
          return i.a.createElement(u.Div, {
            className: "property-creator-property-component"
          }, i.a.createElement(u.Input, {
            label: "Label",
            type: "text",
            onChange: this.onLabelChange,
            value: t
          }));
        }
      }]);

      return LabelOnlyProperty_LabelOnlyProperty;
    }(a.Component);

    var k,
        S,
        B = /*#__PURE__*/function (_a$Component2) {
      _inherits(EnumProperty_EnumProperty, _a$Component2);

      var _super2 = _createSuper(EnumProperty_EnumProperty);

      function EnumProperty_EnumProperty(e) {
        var _this3;

        _classCallCheck(this, EnumProperty_EnumProperty);

        _this3 = _super2.call(this, e), _this3.onLabelChange = function (e) {
          e.persist(), _this3.setState(function (_ref4) {
            var t = _ref4.definition;
            return {
              definition: Object(p.merge)(t, {
                label: e.target.value
              })
            };
          }, _this3.updateParent);
        }, _this3.onValueChange = function (_ref5) {
          var e = _ref5.target.value;
          var t = e.replace(/(?:\r\n|\r|\n)/g, "--new-value--").split("--new-value--").filter(function (e) {
            return "" !== e.trim();
          });

          _this3.setState(function (_ref6) {
            var e = _ref6.definition;
            return {
              definition: Object(p.merge)(e, {
                options: t
              })
            };
          }, _this3.updateParent);
        }, _this3.checkValidity = function () {
          var e = _this3.state.definition.label;
          return !!e && e.length;
        }, _this3.state = {
          isValid: !1,
          definition: {}
        };
        return _this3;
      }

      _createClass(EnumProperty_EnumProperty, [{
        key: "updateParent",
        value: function updateParent() {
          var _this4 = this;

          this.setState({
            isValid: this.checkValidity()
          }, function () {
            return _this4.props.onChange(_this4.state);
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = i.a.createElement(u.Div, {
            className: "property-creator-enum-options-label"
          }, "Options ", i.a.createElement("span", null, "Enter each value on a new line."));
          return i.a.createElement(u.Div, {
            className: "property-creator-property-component"
          }, i.a.createElement(u.Input, {
            label: "Label",
            type: "text",
            onChange: this.onLabelChange
          }), i.a.createElement(u.TextArea, {
            label: e,
            onChange: this.onValueChange
          }));
        }
      }]);

      return EnumProperty_EnumProperty;
    }(a.Component),
        j = [{
      type: "BOOLEAN",
      title: "True/False",
      description: "Users can set a true/false item.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "ENUM",
      title: "Category",
      description: "Users can select a single value from a defined list.",
      component: function component(e) {
        return i.a.createElement(B, e);
      }
    }, {
      type: "ENUMARRAY",
      title: "Multi Category",
      description: "Users can select multiple values from a defined list.",
      component: function component(e) {
        return i.a.createElement(B, e);
      }
    }, {
      type: "DATETIME",
      title: "Date/Time",
      description: "Users can pick a date and time from a calendar.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "DATE",
      title: "Date",
      description: "Users can pick a date from a calendar.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "EMAIL",
      title: "Email",
      description: "Users can enter a valid email address.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "STRING",
      title: "Text",
      description: "Users can enter any combination of letters and numbers.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "NUMBER",
      title: "Number",
      description: "Users can enter any number.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "NUMERIC",
      title: "Number",
      description: "Users can enter any number.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "PHONE",
      title: "Phone",
      description: "Users can enter a valid phone number.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "TEAMMEMBER",
      title: "Team Member",
      description: "Users can enter a team member in Drift.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }, {
      type: "LATLON",
      title: "Geolocation",
      description: "Users can enter a location, which is validated with Google maps.",
      component: function component(e) {
        return i.a.createElement(O, e);
      }
    }],
        T = {
      PLAYBOOK: ["DATETIME", "STRING", "NUMERIC", "BOOLEAN"],
      CONTACT_EVENT: ["DATETIME", "STRING", "NUMERIC", "BOOLEAN"],
      CONTACT: ["STRING", "NUMERIC", "DATETIME", "BOOLEAN"],
      ACCOUNT: ["STRING", "NUMBER", "ENUM"].concat(_toConsumableArray((k = "can_create_multicategory_property", S = "ENUMARRAY", w(k) ? [S] : [])), ["DATETIME", "DATE", "EMAIL", "PHONE", "TEAMMEMBER", "LATLON"])
    },
        N = {
      CONTACT: C,
      CONTACT_EVENT: C,
      PLAYBOOK: C,
      ACCOUNT: _
    },
        P = (r(25), function (_ref7) {
      var e = _ref7.property,
          t = _ref7.onSelect,
          r = _ref7.selected;
      return i.a.createElement(u.Label, {
        className: "property-selector-property"
      }, i.a.createElement(u.Input, {
        type: "radio",
        name: "property-creator",
        checked: r,
        value: e.type,
        onChange: t
      }), i.a.createElement(u.Span, null, e.title), i.a.createElement(u.P, null, e.description));
    }),
        L = function L(_ref8) {
      var e = _ref8.selected,
          t = _ref8.onSelect,
          r = _ref8.type;
      var n = T[r].map(function (e) {
        return j.find(function (t) {
          return t.type === e;
        });
      });
      return i.a.createElement(u.Div, {
        className: "property-selector"
      }, i.a.createElement(u.H3, {
        className: "property-creator-section-title"
      }, "1. Choose an attribute type"), i.a.createElement(u.Div, {
        className: "property-selector-content"
      }, n.map(function (r, n) {
        return i.a.createElement(P, {
          property: r,
          selected: !!e && r.type === e.type,
          onSelect: t,
          key: "property-selector-property-".concat(n)
        });
      })));
    };

    function _objectWithoutProperties(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function _objectWithoutPropertiesLoose(e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            a = Object.keys(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }

    var I = r(16),
        D = r.n(I),
        M = (r(27), function (e) {
      var t = e.selected,
          r = e.onChange,
          n = _objectWithoutProperties(e, ["selected", "onChange"]);

      if (!t) return null;
      var o = t.component;
      return i.a.createElement(u.Div, {
        className: "property-creator-editor"
      }, i.a.createElement(u.H3, {
        className: "property-creator-section-title"
      }, "2. Create ", D()(t.title), " attribute"), i.a.createElement(u.Div, {
        className: "property-creator-editor-content"
      }, i.a.createElement(o, Object.assign({
        onChange: r
      }, n))));
    });
    r(29);
    var U = Object(c.connect)(function (e) {
      return {
        orgId: e.org.id
      };
    }, null)( /*#__PURE__*/function (_a$Component3) {
      _inherits(PropertyCreator_PropertyCreator, _a$Component3);

      var _super3 = _createSuper(PropertyCreator_PropertyCreator);

      function PropertyCreator_PropertyCreator(e) {
        var _this5;

        _classCallCheck(this, PropertyCreator_PropertyCreator);

        var t;
        _this5 = _super3.call(this, e), t = _assertThisInitialized(_this5), _this5.updateDefinition = function (e) {
          _this5.setState(e);
        }, _this5.nextStep = _asyncToGenerator(o.a.mark(function _callee() {
          return o.a.wrap(function _callee$(e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, f(100);

                case 2:
                  t.setState(function (e) {
                    return {
                      step: e.step + 1
                    };
                  });

                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, _callee);
        })), _this5.prevStep = _asyncToGenerator(o.a.mark(function _callee2() {
          return o.a.wrap(function _callee2$(e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, f(100);

                case 2:
                  t.setState(function (e) {
                    return {
                      step: e.step - 1
                    };
                  });

                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, _callee2);
        })), _this5.onSelect = function (e) {
          var t = Object(p.propEq)("type", e.target.value);

          _this5.setState({
            selected: Object(p.find)(t)(j),
            definition: null,
            isValid: !1
          });
        }, _this5.onSave = function () {
          var e,
              t = _this5.props,
              r = t.onSaveSuccess,
              n = t.onSaveError,
              o = t.createType,
              a = _this5.state,
              i = a.definition,
              c = a.selected;
          e = "ACCOUNT" === o ? Object(p.merge)({
            type: c.type,
            starred: !1
          }, i) : [{
            type: c.type,
            name: i.label,
            displayName: i.label
          }], N[o](e).then(r).catch(n);
        }, _this5.state = {
          step: 0,
          selected: null,
          definition: null,
          isValid: !1
        };
        return _this5;
      }

      _createClass(PropertyCreator_PropertyCreator, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.nextStep();
        }
      }, {
        key: "render",
        value: function render() {
          var e,
              t = this.state,
              r = t.definition,
              n = t.step,
              o = t.selected,
              a = t.isValid,
              c = this.props,
              s = c.onCancel,
              p = c.createType;
          return i.a.createElement(u.Div, {
            className: l()("property-creator", "property-creator-step--".concat(n))
          }, i.a.createElement(L, {
            selected: o,
            onSelect: this.onSelect,
            type: p
          }), i.a.createElement(M, {
            selected: o,
            onChange: this.updateDefinition,
            value: null !== (e = null === r || void 0 === r ? void 0 : r.label) && void 0 !== e ? e : ""
          }), 1 === n && i.a.createElement(d, {
            selected: o,
            step: n,
            onNext: this.nextStep,
            onCancel: s
          }), 2 === n && i.a.createElement(y, {
            isValid: a,
            onSave: this.onSave,
            onBack: this.prevStep
          }));
        }
      }]);

      return PropertyCreator_PropertyCreator;
    }(a.Component));

    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }

      return n;
    }

    function _slicedToArray(e, t) {
      return function _arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function _iterableToArrayLimit(e, t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
          var r = [],
              n = !0,
              o = !1,
              a = void 0;

          try {
            for (var i, c = e[Symbol.iterator](); !(n = (i = c.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (s) {
            o = !0, a = s;
          } finally {
            try {
              n || null == c.return || c.return();
            } finally {
              if (o) throw a;
            }
          }

          return r;
        }
      }(e, t) || function _unsupportedIterableToArray(e, t) {
        if (e) {
          if ("string" === typeof e) return _arrayLikeToArray(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
        }
      }(e, t) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    r(31);

    var q = function q(_ref9) {
      var _ref9$className = _ref9.className,
          e = _ref9$className === void 0 ? "" : _ref9$className,
          _ref9$createType = _ref9.createType,
          t = _ref9$createType === void 0 ? "ACCOUNT" : _ref9$createType,
          _ref9$isOpen = _ref9.isOpen,
          r = _ref9$isOpen === void 0 ? !0 : _ref9$isOpen,
          _ref9$onClose = _ref9.onClose,
          n = _ref9$onClose === void 0 ? function () {} : _ref9$onClose,
          _ref9$onSaveError = _ref9.onSaveError,
          o = _ref9$onSaveError === void 0 ? function () {} : _ref9$onSaveError,
          _ref9$onSaveSuccess = _ref9.onSaveSuccess,
          c = _ref9$onSaveSuccess === void 0 ? function () {} : _ref9$onSaveSuccess,
          _ref9$propertyName = _ref9.propertyName,
          s = _ref9$propertyName === void 0 ? "" : _ref9$propertyName,
          _ref9$size = _ref9.size,
          f = _ref9$size === void 0 ? "medium" : _ref9$size;

      var d = _slicedToArray(Object(a.useState)(0), 2),
          y = d[0],
          m = d[1],
          h = _slicedToArray(Object(a.useState)(s), 2),
          A = h[0],
          v = h[1],
          b = _slicedToArray(Object(a.useState)(null), 2),
          g = b[0],
          E = b[1];

      return i.a.createElement(u.Modal, {
        className: l()("property-creator-modal", _defineProperty2({}, e, !!e)),
        footerCopy: i.a.createElement(i.a.Fragment, null, 0 === y && i.a.createElement(i.a.Fragment, null, i.a.createElement(u.Button, {
          onClick: function onClick() {
            return m(function (e) {
              return ++e;
            });
          },
          disabled: !g
        }, "Next"), i.a.createElement(u.Button, {
          onClick: n,
          type: "tertiary"
        }, "Cancel")), 1 === y && i.a.createElement(i.a.Fragment, null, i.a.createElement(u.Button, {
          disabled: !g || !A,
          onClick: function onClick() {
            var e = "ACCOUNT" === t ? {
              label: A,
              starred: !1,
              type: g.type
            } : [{
              displayName: A,
              name: A,
              type: g.type
            }];
            N[t](e).then(c).catch(o);
          }
        }, "Create"), i.a.createElement(u.Button, {
          onClick: function onClick() {
            return m(function (e) {
              return --e;
            });
          },
          type: "tertiary"
        }, "Go back"))),
        onClose: n,
        open: r,
        size: f,
        title: "Create a new ".concat(t.toLowerCase(), " attribute")
      }, 0 === y && i.a.createElement(L, {
        onSelect: function onSelect(e) {
          var t = Object(p.find)(Object(p.propEq)("type", e.target.value))(j);
          E(t);
        },
        selected: g,
        type: t
      }), 1 === y && i.a.createElement(M, {
        onChange: function onChange(_ref10) {
          var e = _ref10.definition;
          v(e.label);
        },
        selected: g,
        value: A
      }));
    },
        R = (r(33), function (_ref11) {
      var e = _ref11.isOpen,
          t = _ref11.close,
          r = _ref11.id,
          n = _ref11.onCancel,
          o = _ref11.onSaveSuccess,
          a = _ref11.onSaveError,
          _ref11$createType = _ref11.createType,
          c = _ref11$createType === void 0 ? "ACCOUNT" : _ref11$createType;
      return i.a.createElement(u.Sidebar, {
        close: t,
        hideOverlay: !0,
        isOpen: e,
        title: "Create a new ".concat(c.toLowerCase(), " attribute")
      }, i.a.createElement(U, {
        onCancel: n,
        onSaveSuccess: o,
        onSaveError: a,
        createType: c
      }));
    });

    r.d(t, "PropertyCreator", function () {
      return U;
    }), r.d(t, "PropertyCreatorModal", function () {
      return q;
    }), r.d(t, "PropertyCreatorSidebar", function () {
      return R;
    });
  }]);
});